import { BarcodeScannerFormat } from '../types'
import { barcodeScannerFormatKinds } from '../constants/format-kinds'
import { isFormatKindApplicable } from './is-format-kind-applicable'

export const findFormatKind = (formats: BarcodeScannerFormat[]) =>
  barcodeScannerFormatKinds.find((formatKind) => isFormatKindApplicable(formats, formatKind))
